<template>
    <section class="bg-gray-50 dark:bg-gray-900 h-full grid grid-cols-1 md:grid-cols-4 gap-4 py-8 px-8">
        <div class="bg-gray-100 dark:bg-gray-800 w-full h-full rounded-lg shadow-lg flex items-center border-l-4 border-green-400 px-4">
            <span class="material-icons-outlined select-none w-1/2 text-center text-7xl text-green-400">
                store
            </span>
            <span class=" w-1/2 h-full flex flex-col px-4 py-2 justify-center">
                <p class="text-green-400 dark:text-green-200 uppercase text-4xl text-center font-bold">{{numLojasAtivas}}</p>
                <p class="text-green-500 uppercase text-xl text-center">Lojas Ativas</p>
            </span>
        </div>
        <div class="bg-gray-100 dark:bg-gray-800 w-full h-full rounded-lg shadow-lg flex items-center border-l-4 border-blue-400 px-4">
            <span class="material-icons-outlined select-none w-1/2 text-center text-7xl text-blue-400">
                add_business
            </span>
            <span class=" w-full h-full flex flex-col px-4 py-2 justify-center">
                <p class="text-blue-400 dark:text-blue-200 uppercase text-4xl text-center font-bold">{{numLojasAdesao}}</p>
                <p class="text-blue-500 uppercase text-xl text-center">Lojas Adesão</p>
            </span>
        </div>
        <div class="bg-gray-100 dark:bg-gray-800 w-full h-full rounded-lg shadow-lg flex flex-wrap items-center border-l-4 border-indigo-400 px-4">
            <span class="material-icons-outlined select-none w-1/2 text-center text-7xl text-indigo-500">
                person
            </span>
            <span class="group w-1/2 flex flex-col px-4 py-2">
                <p class="text-indigo-400 dark:text-indigo-200 uppercase text-4xl text-center font-bold">{{numUsuarios}}</p>
                <p class="text-indigo-500 uppercase text-xl text-center">Usuários</p>
            </span>
        </div>
        <div class="bg-gray-100 dark:bg-gray-800 w-full h-full rounded-lg shadow-lg flex items-center border-l-4 border-yellow-400 px-4">
            <span class="material-icons-outlined select-none w-1/2 text-center text-7xl text-yellow-400">
                today
            </span>
            <span class=" w-full h-full flex flex-col px-4 py-2 justify-center">
                <p class="text-yellow-400 uppercase text-xl text-center">Período</p>
                <p class="text-yellow-300 dark:text-yellow-200 uppercase text-2xl text-center font-bold">{{periodo}}</p>
            </span>
        </div>
        <div class="flex flex-col gap-y-0 w-full rounded-lg py-4 px-4 text-indigo-500 dark:text-purple-300 bg-gray-100 shadow-lg dark:bg-gray-800 col-span-1">
            <span class="material-icons-outlined select-none w-full text-center text-7xl text-purple-500">
                insights
            </span>
            <span class="text-3xl text-center">Métricas pessoais</span>
            <p class="text-gray-400 dark:text-gray-200 text-center">Mostrar dados sobre recolhas dos pesquisadores</p>
            <span class="w-4/5 mt-8 mx-auto">
                <span v-if="!pesquisador" >
                    <span class="material-icons-outlined select-none w-full text-center text-9xl text-gray-600">
                        account_circle
                    </span>
                    <p class="text-gray-500 dark:text-gray-600 text-center mt-2">Não selecionado</p>
                </span>
                <span v-else >
                    <div class="w-28 h-28 rounded-full bg-purple-600 mx-auto">
                        <img v-if="avatarPesquisador" class="rounded-full" draggable="false" :src="avatarPesquisador" alt="">
                        <span v-else class="h-full w-full flex text-gray-100"><p class="m-auto text-5xl">{{pesquisador[0]}}{{pesquisador.split(' ')[1][0]}}</p></span>
                    </div>
                    <p class="text-gray-500 dark:text-gray-200 text-center mt-2">{{pesquisador}}</p>
                </span>
            </span>
            <span class="w-4/5 mt-8 mx-auto">
                <p class="text-gray-400 dark:text-gray-200">Selecionar</p>
                <Autocomplete v-model="pesquisador" placeholder="Selecionar pesquisador" :list="pesquisadores" desc="nome"/>
            </span>
            <span class="w-4/5 mt-4 mx-auto">
                <p class="text-gray-400 dark:text-gray-200 mb-4">No período</p>
                <DatePicker v-model="anomes" />
            </span>

        </div>
        <div class="gap-y-0 w-full rounded-lg py-6 px-8 bg-gray-100 shadow-lg text-gray-100 dark:bg-gray-800 col-span-3">
            <Metrics :metrics="metricas" :pesquisador="pesquisador" @update="updateChart" @changeType="changeChartType"/>
        </div>
    </section>
</template>

<script>
import DatePicker from '../Design/Datepicker.vue'
import { GET_LOJAS_ADESAO, GET_LOJAS_ATIVAS, GET_PESQUISADORES_ADMIN, GET_USUARIOS, METRICAS_PESSOAS } from '../../mixins/api'
import { ref } from '@vue/reactivity'
import Autocomplete from '../Design/Autocomplete.vue'
import Chart from './Chart.vue'
import Metrics from './Metrics.vue'
import { computed, watch } from '@vue/runtime-core'
export default {
    name: 'DashView',
    components: {
        Autocomplete,
        DatePicker,
        Chart,
        Metrics
    },
    setup () {
        const numUsuarios = ref(0)
        const numAdms = ref(0)
        const numPesquisadores = ref(0)
        const numLojasAtivas = ref(0)
        const numLojasAdesao = ref(0)

        const months = [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez'
        ]

        const date = new Date()
        const month = date.getMonth()

        const periodo = months[month] + '/' + date.getFullYear()

        const pesquisador = ref('')
        const pesquisadores = ref([])
        const users = ref([])

        const metricas = ref([])

        const anomes = ref(date.getFullYear().toString() + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)))

        watch(anomes, async (n, o) => {
            await METRICAS_PESSOAS(n).then((results) => {
                metricas.value = results.data
            })
        })
        
        const getAllUsuarios = GET_USUARIOS(100000)
        const getAllLojasAtivas = GET_LOJAS_ATIVAS(1)
        const getAllLojasAdesao = GET_LOJAS_ADESAO(1)
        const getAllPesquisadores = GET_PESQUISADORES_ADMIN()
        const getMetricasUsuarios = METRICAS_PESSOAS(anomes.value)

        Promise.all([getAllUsuarios, getAllLojasAtivas, getAllLojasAdesao, getAllPesquisadores, getMetricasUsuarios]).then((results) => {
            numUsuarios.value = results[0].data.meta.total
            users.value = results[0].data.data
            numPesquisadores.value = results[0].data.data.filter(x => x.role === 'pesquisador').length
            numAdms.value = numUsuarios.value - numPesquisadores.value
            numLojasAtivas.value = results[1].data.meta.total
            numLojasAdesao.value = results[2].data.meta.total
            pesquisadores.value = results[3].data
            metricas.value = results[4].data
        })

        const avatarPesquisador = computed(() => {
            if (users.value.filter(x => x.nome === pesquisador.value)[0]) { return users.value.filter(x => x.nome === pesquisador.value)[0].avatar } else { return '' }
        })

        const chartData = ref({
            lojaAtiva: {
                pendente: [0, 0, 0, 0, 0, 0],
                concluida: [0, 0, 0, 0, 0, 0]
            },
            lojaAdesao: {
                pendente: [0, 0, 0, 0, 0, 0, 0, 0, 0],
                concluida: [0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
        })
        const updateChart = (data) => {
            chartData.value = data
        }
        
        const metricsType = ref(true)
        const changeChartType = (t) => {
            metricsType.value = t
        }

        return {
            numLojasAtivas,
            numLojasAdesao,
            numPesquisadores,
            numUsuarios,
            numAdms,
            periodo,
            pesquisador,
            avatarPesquisador,
            pesquisadores,
            anomes,
            users,
            metricas,
            chartData,
            metricsType,
            updateChart,
            changeChartType

        }
    }

}
</script>
